function addRequiredProps(inputField) {
  return {
    onFocus: () => (true),
    ...inputField,
  };
}

export default addRequiredProps;
